import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './SideBar';

export default function DashboardLayout({ children }) {
  return (
    <Box display="flex" minHeight="100vh">
      <Sidebar />
      <Box flexGrow={1} p={3} sx={{ backgroundColor: '#f5f5f5' }}>
        {children}
      </Box>
    </Box>
  );
}
